class Intertitle {
  constructor(element, duration = 4500) {
    const props = {
      element,
      duration,
      typeof: 'Intertitle',
    };

    Object.assign(this, props);
  }

  play() {
    this.element.classList.add('intertitle--animate');

    // this.timeoutTitle = requestTimeout(() => {
    //   const title = this.element.querySelector('.intertitle__title').innerText;
    //
    //   document.querySelector('.current-chapter__title').innerText = title;
    // }, this.duration / 2);

    this.timeoutStop = requestTimeout(() => {
      this.stop();
    }, this.duration);
  }

  stop() {
    this.element.classList.remove('intertitle--animate');

    cancelTimeout(this.timeoutStop);
  }
}

// TODO: Implementar pausa
